import { AbilityTriggerTypes } from '../enums/AbilityTriggerTypes';

interface AbilityUnit {
  key: string;
  text: string;
}

export interface Ability {
  id: number;
  name: string;
  icon: string;
  canTrigger: boolean;
  triggerType: AbilityTriggerTypes;
  units: AbilityUnit[];
}

export const Abilities = [
  CreateAbility(
    1,
    'Battery Value',
    'battery',
    [CreateUnit('pct', '%')],
    true,
    AbilityTriggerTypes.FallsBelow,
  ),

  CreateAbility(2, 'Location', 'location'),

  CreateAbility(
    3,
    'Temperature',
    'thermometer',
    [CreateUnit('f', '°F'), CreateUnit('c', '°C')],
    true,
    AbilityTriggerTypes.Both,
  ),

  CreateAbility(4, 'Humidity', '', [CreateUnit('pct', '%')], true, AbilityTriggerTypes.Both),

  CreateAbility(
    5,
    'Pressure',
    '',
    [
      CreateUnit('Pa', 'Pa'),
      CreateUnit('Kpa', 'kPa'),
      CreateUnit('Psi', 'psi'),
      CreateUnit('Bar', 'bar'),
      CreateUnit('InHg', 'Inches of Mercury (inHg)'),
    ],
    true,
    AbilityTriggerTypes.Both,
  ),

  CreateAbility(6, 'Vibration', '', [CreateUnit('g', 'g')], true, AbilityTriggerTypes.Both),

  CreateAbility(
    7,
    'Frequency',
    '',
    [CreateUnit('hz', 'Hz'), CreateUnit('khz', 'kHz'), CreateUnit('mhz', 'MHz')],
    true,
    AbilityTriggerTypes.Both,
  ),

  CreateAbility(8, 'Voltage', '', [CreateUnit('v', 'V')], true, AbilityTriggerTypes.Both),

  // CreateAbility(9, 'Spo2', '', [CreateUnit('pct', '%')], true),

  // CreateAbility(10, 'Weight', '', [CreateUnit('lb', 'lbs')], true),

  // CreateAbility(11, 'Blood Pressure', '', [CreateUnit('mmhg', 'mmHg')], true),

  // CreateAbility(12, 'Ecg/Ekg', ''),

  // CreateAbility(13, 'HeartRate', '', [CreateUnit('bpm', 'bpm')], true),

  // CreateAbility(14, 'Systolic', '', [CreateUnit('pct', '%')], true),

  // CreateAbility(15, 'Diastolic', '', [CreateUnit('pct', '%')], true),

  // CreateAbility(16, 'Moisture', '', [CreateUnit('pct', '%')], true, AbilityTriggerTypes.Both),

  CreateAbility(17, 'Light', '', [CreateUnit('pct', '%')], true, AbilityTriggerTypes.Both),

  CreateAbility(18, 'Tamper', '', [CreateUnit('pct', '%')], true, AbilityTriggerTypes.Toggle),

  CreateAbility(19, 'Amperage', '', [CreateUnit('amp', 'A')], true, AbilityTriggerTypes.Both),

  // CreateAbility(20, 'PressureDifferential', '', [CreateUnit('pct', '%')], true),

  CreateAbility(21, 'HealthCheck', '', [CreateUnit('pct', '%')], false),

  CreateAbility(22, 'GatewayHealthCheck', '', [CreateUnit('pct', '%')], false),

  CreateAbility(23, 'Fault', '', [CreateUnit('pct', '%')], true, AbilityTriggerTypes.Toggle),

  CreateAbility(24, 'Orientation', '', [CreateUnit('pct', '%')], true, AbilityTriggerTypes.Both),

  CreateAbility(25, 'Status', '', [CreateUnit('pct', '%')], true, AbilityTriggerTypes.Toggle),

  // CreateAbility(
  //   26,
  //   'Root Mean Square Error',
  //   '',
  //   [CreateUnit('none', 'none')],
  //   true,
  //   AbilityTriggerTypes.Both,
  // ),

  // CreateAbility(
  //   27,
  //   'Root Mean Square Energy',
  //   '',
  //   [CreateUnit('none', 'none')],
  //   true,
  //   AbilityTriggerTypes.Both,
  // ),

  // CreateAbility(
  //   28,
  //   'Zero-crossing Rate',
  //   '',
  //   [CreateUnit('none', 'none')],
  //   true,
  //   AbilityTriggerTypes.Both,
  // ),

  // CreateAbility(29, 'Chromagram', '', [CreateUnit('none', 'none')], true, AbilityTriggerTypes.Both),

  // CreateAbility(
  //   30,
  //   'Spectral Centroid',
  //   '',
  //   [CreateUnit('hz', 'Hz')],
  //   true,
  //   AbilityTriggerTypes.Both,
  // ),

  // CreateAbility(
  //   31,
  //   'Spectral Bandwidth',
  //   '',
  //   [CreateUnit('hz', 'Hz')],
  //   true,
  //   AbilityTriggerTypes.Both,
  // ),

  // CreateAbility(
  //   32,
  //   'Spectral Rolloff',
  //   '',
  //   [CreateUnit('hz', 'Hz')],
  //   true,
  //   AbilityTriggerTypes.Both,
  // ),

  // CreateAbility(33, 'Speed', '', [CreateUnit('none', 'none')], true, AbilityTriggerTypes.Both),

  // CreateAbility(34, 'Heading', '', [CreateUnit('deg', '°')], true, AbilityTriggerTypes.Both),

  // CreateAbility(35, 'Altitude', '', [CreateUnit('none', 'none')], true, AbilityTriggerTypes.Both),

  // CreateAbility(36, 'Odometer', '', [CreateUnit('none', 'none')], true, AbilityTriggerTypes.Both),

  // CreateAbility(37, 'Hours', '', [CreateUnit('hr', 'hr')], true, AbilityTriggerTypes.Both),

  // CreateAbility(38, 'Fuel Level', '', [CreateUnit('pct', '%')], true, AbilityTriggerTypes.Both),

  // CreateAbility(
  //   39,
  //   'Fuel Consumption',
  //   '',
  //   [CreateUnit('none', 'none')],
  //   true,
  //   AbilityTriggerTypes.Both,
  // ),

  // CreateAbility(40, 'RPM', '', [CreateUnit('rpm', 'RPM')], true, AbilityTriggerTypes.Both),

  // CreateAbility(41, 'Spectrogram', '', [CreateUnit('none', 'none')], false),

  CreateAbility(42, 'Sound', '', [CreateUnit('dB', 'dB')], true, AbilityTriggerTypes.Both),

  CreateAbility(43, 'TVOC', '', [CreateUnit('ppm', 'ppm')], true, AbilityTriggerTypes.Both),

  CreateAbility(44, 'IAQ', '', [CreateUnit('none', 'none')], true, AbilityTriggerTypes.Both),

  // CreateAbility(75, 'Power', '', [CreateUnit('w', 'W')], true, AbilityTriggerTypes.Both),

  // CreateAbility(
  //   76,
  //   'Power Consumption',
  //   '',
  //   [CreateUnit('kwh', 'kWh')],
  //   true,
  //   AbilityTriggerTypes.Both,
  // ),

  // CreateAbility(
  //   77,
  //   'Power Factor',
  //   '',
  //   [CreateUnit('none', 'none')],
  //   true,
  //   AbilityTriggerTypes.Both,
  // ),

  // CreateAbility(
  //   78,
  //   'Battery Change',
  //   '',
  //   [CreateUnit('none', 'none')],
  //   true,
  //   AbilityTriggerTypes.Toggle,
  // ),

  // CreateAbility(79, 'Time', '', [CreateUnit('none', 'none')], true, AbilityTriggerTypes.Both),

  // CreateAbility(80, 'Length', '', [CreateUnit('none', 'none')], true, AbilityTriggerTypes.Both),

  // CreateAbility(81, 'Mass', '', [CreateUnit('none', 'none')], true, AbilityTriggerTypes.Both),

  // CreateAbility(
  //   82,
  //   'Open Count',
  //   '',
  //   [CreateUnit('count', 'count')],
  //   true,
  //   AbilityTriggerTypes.Both,
  // ),

  // CreateAbility(
  //   83,
  //   'Close Count',
  //   '',
  //   [CreateUnit('count', 'count')],
  //   true,
  //   AbilityTriggerTypes.Both,
  // ),

  // CreateAbility(
  //   84,
  //   'Tamper Count',
  //   '',
  //   [CreateUnit('count', 'count')],
  //   true,
  //   AbilityTriggerTypes.Both,
  // ),

  // CreateAbility(85, 'Energy', '', [CreateUnit('kwh', 'kWh')], true, AbilityTriggerTypes.Both),

  // CreateAbility(
  //   86,
  //   'Motion',
  //   '',
  //   [CreateUnit('none', 'none')],
  //   true,
  //   AbilityTriggerTypes.Toggle,
  // ),

  // CreateAbility(
  //   87,
  //   'Button Press',
  //   '',
  //   [CreateUnit('none', 'none')],
  //   true,
  //   AbilityTriggerTypes.Toggle,
  // ),

  // CreateAbility(88, 'PM2.5', '', [CreateUnit('ugm3', 'µg/m³')], true, AbilityTriggerTypes.Both),

  CreateAbility(
    89,
    'Electromagnetic Activity Index (EMF)',
    '',
    [CreateUnit('none', 'none')],
    true,
    AbilityTriggerTypes.Both,
  ),

  // CreateAbility(
  //   90,
  //   'Signal Strength',
  //   '',
  //   [CreateUnit('dbm', 'dBm')],
  //   true,
  //   AbilityTriggerTypes.Both,
  // ),

  // CreateAbility(91, 'Uptime', '', [CreateUnit('none', 'none')], true, AbilityTriggerTypes.Both),

  // CreateAbility(92, 'Link Quality', '', [CreateUnit('pct', '%')], true, AbilityTriggerTypes.Both),
];

function CreateUnit(key: string, text: string) {
  return {
    key: key,
    text: text,
  } as AbilityUnit;
}

function CreateAbility(
  id: number,
  name: string,
  icon: string,
  units: AbilityUnit[] = [CreateUnit('none', 'none')],
  canTrigger: boolean = false,
  triggerType: AbilityTriggerTypes = AbilityTriggerTypes.Both,
) {
  return {
    id: id,
    name: name,
    icon: icon,
    canTrigger: canTrigger,
    triggerType: triggerType,
    units: units,
  } as Ability;
}
